import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const footerLinks = {
  shop: [
    { name: 'Cashmere Capes', path: '/shop?category=cashmere-capes-ponchos' },
    { name: 'Pullovers', path: '/shop?category=cashmere-pullovers' },
    { name: 'Cashmere Caps', path: '/shop?category=cashmere-caps' },
    { name: 'Tribal Ponchos', path: '/shop?category=tribal-ponchos' },
    { name: 'Yoga Pants', path: '/shop?category=tribal-shorts' },
  ],
  support: [
    { name: 'About Us', path: '/about' },
    { name: 'Contact', path: '/contact' },
    { name: 'Privacy Policy', path: '/privacy-policy' },
    { name: 'Terms of Service', path: '/terms-of-service' },
  ],
};

const paymentMethods = ['Visa', 'Mastercard', 'Amex', 'Apple Pay'];

export const Footer = () => {
  return (
    <footer className="footer-bg" data-testid="footer">
      {/* Benefit Banner */}
      <div className="border-b border-[#4A3F3A]">
        <div className="container-luxury py-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            <div data-testid="benefit-free-shipping">
              <p className="text-xs uppercase tracking-widest text-[#C6A87C] mb-1">
                Shipping Based on Location
              </p>
              <p className="text-sm text-[#8C8580]">Free shipping on orders above €150</p>
            </div>
            <div data-testid="benefit-free-returns">
              <p className="text-xs uppercase tracking-widest text-[#C6A87C] mb-1">
                Free Returns
              </p>
              <p className="text-sm text-[#8C8580]">Easy 30-day return policy</p>
            </div>
            <div data-testid="benefit-quality">
              <p className="text-xs uppercase tracking-widest text-[#C6A87C] mb-1">
                Premium Quality
              </p>
              <p className="text-sm text-[#8C8580]">100% authentic materials</p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="container-luxury py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="font-heading text-2xl text-[#F9F8F6] mb-4">
              Shiva Shakti
            </h3>
            <p className="text-sm text-[#8C8580] leading-relaxed mb-6 font-accent italic">
              "Where Himalayan heritage meets contemporary elegance."
            </p>
            <div className="space-y-3">
              <a
                href="tel:+4917667405770"
                className="flex items-center gap-3 text-sm text-[#8C8580] hover:text-[#C6A87C] transition-colors"
                data-testid="footer-phone"
              >
                <Phone size={16} />
                +49 17667405770
              </a>
              <a
                href="mailto:prabalbansal11@gmail.com"
                className="flex items-center gap-3 text-sm text-[#8C8580] hover:text-[#C6A87C] transition-colors"
                data-testid="footer-email"
              >
                <Mail size={16} />
                prabalbansal11@gmail.com
              </a>
            </div>
          </div>

          {/* Shop Links */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-[#F9F8F6] mb-6">
              Shop
            </h4>
            <ul className="space-y-3">
              {footerLinks.shop.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-[#8C8580] hover:text-[#C6A87C] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-[#F9F8F6] mb-6">
              Support
            </h4>
            <ul className="space-y-3">
              {footerLinks.support.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-[#8C8580] hover:text-[#C6A87C] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Payment Methods */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-[#F9F8F6] mb-6">
              Secure Payment
            </h4>
            <div className="flex flex-wrap gap-3">
              {paymentMethods.map((method) => (
                <span
                  key={method}
                  className="px-3 py-2 bg-[#4A3F3A] text-xs text-[#8C8580] rounded"
                >
                  {method}
                </span>
              ))}
            </div>
            <p className="text-xs text-[#8C8580] mt-6">
              All transactions are secured with SSL encryption.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#4A3F3A] mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#8C8580]">
            © {new Date().getFullYear()} Shiva Shakti Garments. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link
              to="/privacy-policy"
              className="text-xs text-[#8C8580] hover:text-[#C6A87C] transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-of-service"
              className="text-xs text-[#8C8580] hover:text-[#C6A87C] transition-colors"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
